const openedSubmenuKeys = new Set<string>();
let isListeningForPointerDown = false;

const clearOpenedSubmenuKeys = () => openedSubmenuKeys.clear();

/**
 * True the first time a submenu with this key opens after the latest pointer press. Every root menu
 * opens with a press (right-click, ellipsis click), while re-hovering a submenu trigger reopens the
 * submenu without one, so this counts once per root menu open on every surface, however often the
 * surface rebuilds or memoizes its options. Keyboard-only reopens of the same key are not counted.
 */
export const isFirstSubmenuOpenSincePointerDown = (key: string) => {
  if (!isListeningForPointerDown && typeof window !== 'undefined') {
    window.addEventListener('pointerdown', clearOpenedSubmenuKeys, { capture: true });
    isListeningForPointerDown = true;
  }

  if (openedSubmenuKeys.has(key)) {
    return false;
  }

  openedSubmenuKeys.add(key);
  return true;
};
